var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePaymentRadioInput',{attrs:{"selected-payment-method":_vm.selectedPaymentMethod,"numeric-value":2,"name":"transfer","title-text":_vm.$t('form.bank-transfer-payment-method.title'),"subtitle-text":_vm.$t('form.bank-transfer-payment-method.subtitle'),"update-value":(value) => _vm.$emit('update-payment-method', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }